import {
  Typography,
  Grid,
  List,
  ListItem,
  ListItemText,
  Button,
  Card,
  CardContent,
  Divider,
  Box,
  Dialog,
  Backdrop,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  Stack,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import "./index.scss";
import AllUrls from "../../../../../../Utils/axr";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../../../hooks";
import { makeQuickPaymentMethod } from "../../../../../../../../shared/hooks/useFetchPayment";
import { ErrorPaymentModal } from "../../utils/ErrorPaymentModal/ErrorPaymentModal";
import closeIconPng from "../../../../../../assets/images/Close.png";
import { dwLogging } from "../../../../../../../../shared/hooks/useFetchLogin";
import ApiUrls from "../../../../../../Utils/axr";
import { EC_DW_LOGGING_STEPS } from "../../../../../../../../shared/utils/Constants";
import useBrightspeedHeaders from "../../../../../../hooks/useBrightspeedHeader";
import { getquickBillPayPageContent } from "../../../../../../SharedContextStore/slices/contents/qbpContentAem";
import { format as dateFormat } from "date-fns";
import ScheduledPayments from "../../../../../../SharedComponents/paymentScheduled";
import ScrollToTop from "../../../../../../Utils/ScrollToTop";
import DwLogutil from "../../../../../../Utils/DwLogutil";
import { useCustomNavigate } from "../../../../../../Utils/navigationUtils";
import { QuickBillPay } from "../../../../../../SharedComponents/contents";
import { qbpPaymentsGTM, sendEventGTMLog } from "../../../../../../Utils/googleTags";
import { sendEventLog } from "../../../../../../Utils/app-log";
import { getNextPaymentDetails } from "../../../../../../SharedContextStore/slices/nextPaymentDetails";
import store from "../../../../../../SharedContextStore/store";
import { getPaymentHistory } from "../../../../../../SharedContextStore/slices/paymentHistory";

interface LooseObject {
  [key: string]: any
}

export const VerifyInformation = (props: any) => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const { customNavigate } = useCustomNavigate();
  const QBP_CONTENT_2: any = QuickBillPay();
  const QBP_CONTENT_Data: any = useAppSelector(
    (state) => state.quickBillPayContent?.quickBillPayPageContent
  );
  const reduxStore = store.getState();
  useEffect(() => {
    if(!QBP_CONTENT_Data) {
    dispatch(getquickBillPayPageContent())
    }
  }, [])

  const CreditCardDetails = useAppSelector(
    (state) => state.paymentMethods.autoPaymentMethods
  );
  const BankDetailsCard = useAppSelector(
    (state) => state.paymentMethods.autoPaymentMethods
  );
  
  const globalToken = useAppSelector((state) => state?.brightspeedToken?.data);
  const { sessionId, companyName } = useAppSelector((state) => state.user);

  const UserSessionDetails = useAppSelector((state) => state.user.data);
  const navigation = useNavigate();
  const user = useAppSelector((state) => state.user.data);
  const headers = useBrightspeedHeaders();
  const nextPaymentDetails = useAppSelector(({ nextPaymentDetails }) => nextPaymentDetails);
  const dataInstallments = useAppSelector((state) => state.paymentHistoryForPA?.paymentHistory?.treatment)

  const {
    qbp_cancel_step2,
    qbp_success,
    qbp_failed,
    unauthqbp_cancel_step2,
    unauthqbp_success,
    unauthqbp_failed,
    qbp_attempted,
    unauthqbp_attempted
  } = EC_DW_LOGGING_STEPS

  const activeStep1 = (isEdit: Boolean) => {
    if(props.isUnAuthQbp) {
      return props.activeStep1(
        true,
        '',
        {},
        props.amountValue,
        false
      );
    }

    return props.activeStep1(
      true,
      props.selectedPaymentCard,
      props.cardInformation,
      props.amountValue,
      isEdit
    );
  };

  const activeStep3 = (confirmationCode: any) => {
    props.activeStep3(
      true,
      props.selectedPaymentCard,
      informationCard,
      totalCharged,
      billAmount,
      confirmationCode
    );
  };
  const ReturnToMyBills = () => {
    const stepName = props?.isUnAuthQbp
            ? unauthqbp_cancel_step2
            : qbp_cancel_step2;
    const flowType = user?.data?.currentStatus;
    const navigateTo = props?.isUnAuthQbp
            ? "/non-auth-quick-bill-pay"
            : "/my-bills/view-payments";

    DwLogutil({ stepName, flowType });
    navigation( navigateTo );
  };
  const [bankCard, setBankCardDetails] = useState<any>([]);
  const [creditCard, setCreditCardDetails] = useState<any>([]);
  const [showSubmitPaymentErrorModal, setErrorPaymentModal] =
    useState<boolean>(false);
  const [showConvenienceFee, setShowConvienence] = useState<boolean>(true);
  const [paymentSelected, setPaymentSelected] = useState<any>(
    props.selectedPaymentCard
  );
  const [informationCard, setInformationCard] = useState<any>(
    props.cardInformation
  );
  const [isSubmitLoader, setIsSubmitLoader] = useState(false);

  const [paymentInformation, setPaymentInformation] = useState<any>({});
  const [totalCharged, setTotalCharged] = useState<any>(0);
  const [billAmount, setBillAmount] = useState<number>(0);
  const [amountWithNoFee, setAmounWithtNoFee] = useState<any>(props.amount);
  const handleInfoCardProp = () => {
    if (props.cardInformation) {
      setInformationCard(props.cardInformation);
    }
  };
  //**THIS METHOD ADD THE FEE AMOUNT TO THE CURRENT AMOUNT IF USER PAYS WITH CREDIT CARD ONLY */
  const feeCalculation = () => {
    let total: any = parseFloat(amountWithNoFee).toFixed(2);
    setBillAmount(total);
    setAmounWithtNoFee(total);

    switch (paymentSelected) {
      case "Bank Account":
        setTotalCharged(total);
        break;
      case "Credit Card":
        total = parseFloat(total) + 3.5;
        setTotalCharged(total.toFixed(2));
        break;
    }
  };

  const dwLogsForSubmitPaymentClick = (status:any) => {
    dwLogging(
      {
        "": ApiUrls?.dwLoggingUrl,
      },
      {
        sessionId: sessionId || sessionStorage?.getItem("sessionId") || "",
        stepName: (status >= 200 && status <= 300)? EC_DW_LOGGING_STEPS.payment_successful : EC_DW_LOGGING_STEPS.payment_failed,
        cta: "Success",
        userEmail: user?.email,
        customerType: companyName || "",
      },
      {
        ...headers,
        "access-token": reduxStore?.brightspeedToken?.headers?.['access-token']
      }
    );
  };
  //**This method make a post call to qbp api call and send the payload,paymentAuthId,creditAccount and bpno are required */
  const onPressSubmitPayments = async () => {
    const { invoiceId = '', nextPayment, InvoiceAmount } = nextPaymentDetails?.nextPaymentDetails
    setIsSubmitLoader(true);
    const selction= localStorage.getItem("qpb_selection_type");
    props.isUnAuthQbp 
      ? DwLogutil({
          stepName: unauthqbp_attempted
        })
      : DwLogutil({
          stepName: qbp_attempted,
          flowType: user?.currentStatus
        });

    if(props.isUnAuthQbp)  {
       sendEventLog({
          stepName: unauthqbp_attempted
        }, {unauthqbp_attempted: unauthqbp_attempted});
        sendEventGTMLog(unauthqbp_attempted, companyName);
      } else { sendEventLog({
          stepName: qbp_attempted
        }, { unauthqbp_attempted: unauthqbp_attempted});
         sendEventGTMLog(qbp_attempted, companyName);
      } 
    const stepname_att_with =
      selction === "email" ?
        EC_DW_LOGGING_STEPS?.unauthqbp_attempted_email :
        selction === "ban" ?
          EC_DW_LOGGING_STEPS?.unauthqbp_attempted_ban
          :
          EC_DW_LOGGING_STEPS?.unauthqbp_attempted_phone

    if (props.isUnAuthQbp) {
      DwLogutil({
        stepName: stepname_att_with
      })
    }


    const submitPayload: LooseObject = {
      paymentAuthId: informationCard?.id,
      creditAccount: UserSessionDetails?.billingAccountNumber,
      emailAddress: UserSessionDetails.email,
      amount: billAmount, //totalCharged,
      debitName: `${UserSessionDetails?.firstName} ${UserSessionDetails.lastName}`,
      zipCode: UserSessionDetails?.addresses[0]?.zip,
      paymentMethod: { paymentType: showConvenienceFee ? "Card" : "ACH" }
    }

    const invoiceNo = 
      nextPayment && InvoiceAmount && parseInt(nextPayment) > parseInt(InvoiceAmount)
      ? ""
      : invoiceId;

    submitPayload.invoiceData = [{
      bpno: UserSessionDetails?.billingAccountNumber,
      invoiceNo,
      // invoiceNo: nextPaymentDetails?.invoiceId,
      amount: billAmount, //CC - Amt without Convenience fee. // totalCharged, 
      currency: "USD",
    }]

    const headers = {
      Authorization:
        process.env.REACT_APP_ENV === "production"
          ? `Bearer ${globalToken?.access_token}`
          : "",
      brspdChId: "web-acm",
      channel: "web-acm",
      sessionId: sessionId || sessionStorage?.getItem("sessionId") || "",
      siteid: companyName,
    };

    if (props.isUnAuthQbp) { 
      qbpPaymentsGTM({
        event: "non_auth_qbp_payment_attempted"
      })
    }
    else {
      qbpPaymentsGTM({
        event: "auth_qbp_payment_attempted"
      })
    }

    try {
      const qbpCall = await makeQuickPaymentMethod(
        {
          "": AllUrls.quickPayURL,
        },
        submitPayload,
        {
          ...headers,
          "access-token": reduxStore?.brightspeedToken?.headers?.['access-token']
        }
      );
      if (qbpCall.status >= 200 && qbpCall.status <= 300) {
        // dwLogsForSubmitPaymentClick(qbpCall.status)
        if (props.isUnAuthQbp){
          DwLogutil({
            stepName: unauthqbp_success,
            message: `Amount: ${billAmount}`
          })
          sendEventLog(unauthqbp_success, {unauthqbp_success: unauthqbp_success});
          qbpPaymentsGTM({
            event: "non_auth_qbp_payment_success"
          })
        } else {
          DwLogutil({
            stepName: qbp_success,
            message: `Amount: ${billAmount}`,
            flowType: user?.currentStatus
          });
          sendEventLog(qbp_success, {"flowType": user?.currentStatus});
          qbpPaymentsGTM({
            event: "auth_qbp_payment_success"
          })
        user?.billingAccountNumber &&  await dispatch(getNextPaymentDetails(user?.billingAccountNumber)); // calling payment api to get updated balance ammount
        }

    const stepname_with =
     selction ==="email" ?
      EC_DW_LOGGING_STEPS?.unauthqbp_success_email :
      selction ==="ban"?
      EC_DW_LOGGING_STEPS?.unauthqbp_success_ban
      :
      EC_DW_LOGGING_STEPS?.unauthqbp_success_phone

      if(props.isUnAuthQbp){
      DwLogutil({ headers, sessionId, email:localStorage?.getItem("qpb_selectedOption") || "",companyName,stepName:stepname_with});
      }

        user?.billingAccountNumber &&  dispatch(getPaymentHistory(user?.billingAccountNumber));
        setIsSubmitLoader(false)
        setErrorPaymentModal(false);
        localStorage.setItem("confirmationCode",qbpCall?.data?.confirmationCode)
        activeStep3(qbpCall?.data?.confirmationCode);
      } else {
        setIsSubmitLoader(false)
        setErrorPaymentModal(true);
        if (props.isUnAuthQbp) { 
          DwLogutil({
            stepName: unauthqbp_failed,
            error: 'API success with empty response'
          });
          sendEventLog(unauthqbp_failed, {"reason":"API success with empty response"});
          qbpPaymentsGTM({
            event: "non_auth_qbp_payment_failure",
            error: 'API success with empty response'
          })
        }
        else {
          DwLogutil({
            stepName: qbp_failed,
            error: 'Error',
            flowType: user?.currentStatus
          });
          sendEventLog(qbp_failed, {"flowType": user?.currentStatus});
          qbpPaymentsGTM({
            event: "auth_qbp_payment_failure",
            error: 'API success with empty response'
          })
        }
    const stepname_with =
    selction ==="email" ?
     EC_DW_LOGGING_STEPS?.unauthqbp_failed_email :
     selction ==="ban"?
     EC_DW_LOGGING_STEPS?.unauthqbp_failed_ban
     :
     EC_DW_LOGGING_STEPS?.unauthqbp_failed_phone

     if(props.isUnAuthQbp){
     DwLogutil({ headers, sessionId, email:localStorage?.getItem("qpb_selectedOption") || "",companyName,stepName:stepname_with, error: 'Error'});
     }
     
      }
    }
    catch (error:any) {
      setIsSubmitLoader(false)
      setErrorPaymentModal(true);
      if (props.isUnAuthQbp ) {

        DwLogutil({
          stepName: unauthqbp_failed,
          error: error.response.data.exception.message || error.request.status || 'Error'
        });
        sendEventLog(unauthqbp_failed, {"reason": error.response.data.exception.message || error.request.status || 'Error'});
        qbpPaymentsGTM({
          event: "non_auth_qbp_payment_failure",
          error: error.response.data.exception.message|| error.request.status || 'Exception occured'
        })
      } else {
        DwLogutil({
          stepName: qbp_failed,
          error: error.response.data.exception.message || error.request.status || 'Error',
          flowType: user?.currentStatus
        });
        sendEventLog(qbp_failed, {"flowType": user?.currentStatus});
        qbpPaymentsGTM({
          event: "auth_qbp_payment_failure",
          error: error.response.data.exception.message || error.request.status || 'Exception occured'
        })
      }

          const stepname_with =
    selction ==="email" ?
     EC_DW_LOGGING_STEPS?.unauthqbp_failed_email :
     selction ==="ban"?
     EC_DW_LOGGING_STEPS?.unauthqbp_failed_ban
     :
     EC_DW_LOGGING_STEPS?.unauthqbp_failed_phone
     if(props.isUnAuthQbp){
     DwLogutil({ headers, sessionId, email:localStorage?.getItem("qpb_selectedOption") || "",companyName,stepName:stepname_with, error: JSON.stringify(error)});
     }
      setIsSubmitLoader(false)
      setErrorPaymentModal(true);
      console.error("Error => ", error.request.status);
    }
  };

  useEffect(() => {
    handleInfoCardProp();
    feeCalculation();
    if (paymentSelected === "Bank Account") {
      setShowConvienence(false);
      setInformationCard(props.cardInformation);
    } 
    else if (paymentSelected === "Credit / Debit Card") {
      setShowConvienence(true);
    }
    setCreditCardDetails(CreditCardDetails);
    setBankCardDetails(BankDetailsCard);
  }, [
    CreditCardDetails,
    BankDetailsCard,
    props.cardInformation,
    handleInfoCardProp,
    feeCalculation,
    paymentSelected,
  ]);

  const paymentInstallments = dataInstallments?.length ? dataInstallments[0]?.installment : [];

  return (
    <Box className="VerifyInformationCard">
      <ScrollToTop top={40} />

      {/*paymentInstallments?.length 
      && <Card className="AmountInformationCard">
          <CardContent className="billDetails">
            <Typography
              variant="h6"
              color="initial"
              className="TitleStep1"
              sx={{ marginTop: 2 }}
            >
              {
                'Payment plan details'
              }
            </Typography>
            <Divider />
           
            <Box className="payment-scheduled">
               <ScheduledPayments/>
            </Box>
            
            <Box className="payment-scheduled">
              <Typography className="nonAuthEligibilityModalRequiredMessage title-line">
                *Installments need to be paid in addition to your monthly bill. If you fail to make the agreed upon payments by the dates shown, then your payment arrangement will be canceled and you will immediately owe the full amount due. You will not be eligible to make another payment arrangement for 3 months.
              </Typography>
            </Box>
          </CardContent>
        </Card>
      */}

      <Card role="region" aria-label={QBP_CONTENT_2?.entry?.qbp_flow?.review_payment_details?.general_title}>
        <CardContent className="paymentDetails">
              <Typography variant="body1" color="initial" className="titleStep2" component="h2" id="selectPayMethod">
                {" "}
                {QBP_CONTENT_2?.entry?.qbp_flow?.review_payment_details?.general_title}
              </Typography>
              
              <Divider role="presentation" />

              <Box sx={{display:"flex"}} className="AmountsInformation">
                {/* First Column */}
                <Box>
                  {props.isUnAuthQbp && <Typography variant="subtitle1" color="initial" className="heading">
                    {
                      <>
                        <span>{QBP_CONTENT_2?.entry?.qbp_flow?.review_payment_details?.onetime_payment_title}</span>
                        <strong>{` ****${user?.billingAccountNumber?.slice(-4)}`}</strong>
                      </> 
                    }
                  </Typography>}
                  <TableContainer>
                  <Table sx={{ tableLayout: "fixed" }}>         
                  <caption style={{ opacity: "0", position: "absolute" }} className="p-0">{QBP_CONTENT_2?.entry?.qbp_flow?.review_payment_details?.general_title}</caption>        
                  <TableBody>
                    <TableRow className="paymentDatelabel">
                      <TableCell className="p-0 border-0">
                      <Typography
                        // sx={{ marginTop: "32px" }}
                        className="titlesInfo1 marbot24">
                        {QBP_CONTENT_2?.entry?.qbp_flow?.review_payment_details?.titles?.payment_date_label}
                      </Typography>
                      </TableCell>
                      <TableCell className="p-0 border-0">
                      <Typography
                        style={{ textAlign: "end"}}                        
                        className="listItemsCustom marbot24"
                      >
                        {dateFormat(new Date(), "M/d/yyyy")}
                      </Typography>
                      </TableCell>
                    </TableRow>
                    <TableRow className="paymentDatelabel">
                    <TableCell className="p-0 border-0">
                      <Typography                        
                        className="titlesInfo2 marbot24"
                      >
                        {QBP_CONTENT_2?.entry?.qbp_flow?.review_payment_details?.titles?.payment_method_label}
                      </Typography>
                      </TableCell>
                      <TableCell className="p-0 border-0">
                      <Typography
                        className="listItemsCustom marbot24"
                        style={{ textAlign: "end" }} >
                        {
                          informationCard?.bankAccountNumber && `${informationCard.type} **** ${informationCard.bankAccountNumber.slice(-4)}` 
                          || informationCard?.cardNumber && `${informationCard.creditCardType?.toLowerCase() || informationCard.type?.toLowerCase()} **** ${informationCard.cardNumber.slice(12)}`
                        }
                      </Typography>
                    </TableCell>
                    </TableRow >
                      
                    {showConvenienceFee ? (
                      <>
                         <TableRow className="paymentDatelabel">
                         <TableCell className="p-0 border-0">
                          <Typography                            
                            className="titlesInfo2 marbot24"
                          >
                          {QBP_CONTENT_2?.entry?.qbp_flow?.review_payment_details?.titles?.bill_payment_label}
                          </Typography>
                          </TableCell>
                          <TableCell className="p-0 border-0">
                          <Typography
                            style={{ textAlign: "end" }}                            
                            className="listItemsCustom 123 marbot24"
                          >
                            {billAmount ? `$${billAmount}` : '$0.00'}
                          </Typography>
                          </TableCell>
                        </TableRow>
                      </>
                    ) : (
                      ""
                    )}
                    {showConvenienceFee ? (
                      <>
                        <TableRow className="paymentDatelabel">
                        <TableCell className="p-0 border-0">
                          <Typography                            
                            className="titlesInfo2 marbot24"
                          >
                            {QBP_CONTENT_2?.entry?.qbp_flow?.confirmation_payment_details?.payment_details_titles?.convenience_fee_label}
                          </Typography>
                          </TableCell>
                          <TableCell className="p-0 border-0">
                          <Typography style={{ textAlign: "end" }} className="listItemsCustom marbot24">
                            {"$3.50"}
                          </Typography>
                          </TableCell>                       
                        </TableRow>
                      </>
                    ) : (
                      ""
                    )}
                     <TableRow className="paymentDatelabel">
                     <TableCell className="p-0 border-0">
                      <Typography
                        style={{ fontWeight: "bold" }}                        
                        className="totalAmountCharged"
                      >
                      {QBP_CONTENT_2?.entry?.qbp_flow?.review_payment_details?.titles?.amount_charged}
                      </Typography>
                      </TableCell>
                      <TableCell className="p-0 border-0">
                      <Typography
                        style={{ fontWeight: "bold" }}                        
                        className="listItemsCustom text-color-primary totalAmountCharged"
                      >
                       {totalCharged ? `$${totalCharged}`: '$0.00'}
                      </Typography>
                      </TableCell>
                    </TableRow>
                    </TableBody>
                  </Table>
                  </TableContainer>
                </Box>
              </Box>
              {showConvenienceFee && (
                <Typography variant="body2" color="initial" className="convenienceFeeDescriptions" component="h6">
                  {QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.payment_descriptions?.credit_card_convenience_check}
                </Typography>
              )}

              <p className="descriptionCharges">{QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.payment_descriptions?.submit_payment_msg}<span>{totalCharged}</span>. {showConvenienceFee && (<span>{QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.payment_descriptions?.convenience_fee_1}</span>)}</p>

              {showSubmitPaymentErrorModal &&
              <Dialog
              className="addPaymentNew"
              sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={showSubmitPaymentErrorModal}
              // aria-describedby="Payment-dialog-description"
              aria-labelledby="Payment-dialog-title"
              >
                <Box className={"addNewPaymentMethod text-color-primary"}>
                  <Typography className="modal-title font-primary" component="h2" id="Payment-dialog-title">
                    {QBP_CONTENT_2?.entry?.qbp_flow?.review_payment_details?.descriptions?.errorpayment?.payment_not_processed}
                  </Typography>
                  <Typography className="mt-3">
                    {QBP_CONTENT_2?.entry?.qbp_flow?.review_payment_details?.descriptions?.errorpayment?.check_payment_details}
                  </Typography>
                  <Typography className="mt-3">
                    {QBP_CONTENT_2?.entry?.qbp_flow?.review_payment_details?.descriptions?.errorpayment?.help_through}
                    {" "}
                    <span className="text-nowrap">{QBP_CONTENT_2?.entry?.qbp_flow?.review_payment_details?.descriptions?.errorpayment?.help_line}</span>
                  </Typography>
                </Box>
                <Box className="payment-overlay-cta">
                  <Button
                    className="cancelBtn"
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      setErrorPaymentModal(false);
                      activeStep1(false);
                      props.isUnAuthQbp && customNavigate('/non-auth-quick-bill-pay');
                    }}
                    sx={{marginRight: '24px'}}
                  >
                    {((_failButtonValue) => QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.buttons_labels?.cancel)()}
                  </Button>
                  <Button
                    className="btnConfirm"
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      setErrorPaymentModal(false);
                      activeStep1(true);
                    }}
                  >
                    {((_failButtonValue) => QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.buttons_labels?.edit)()}
                  </Button>
                </Box>
              <Stack
                direction="row"
                justifyContent="end"
                className="close-icon-cantainer"
              >
                <Box className="closeIcon">
                  <Typography component="button" className="buttonText" aria-label="Close the dialog" onClick={() => setErrorPaymentModal(false)}>
                    <img src={closeIconPng} alt="Close the dialog" />
                  </Typography>
                </Box>
              </Stack>
              </Dialog>
              }

              <Box className="page-cta">
                <Button variant="outlined" onClick={ReturnToMyBills} className="cancel-button">{QBP_CONTENT_2?.entry?.qbp_flow?.review_payment_details?.button_labels?.cancel}</Button>
                <Button variant="contained" onClick={onPressSubmitPayments} className="continue-button">{QBP_CONTENT_2?.entry?.qbp_flow?.review_payment_details?.button_labels?.submit_payment}</Button>
              </Box>

              <Backdrop
                className="custom-loader-backdrop"
                sx={{ color: "#fff", zIndex: (theme: any) => theme.zIndex.drawer + 2 }}
                open={isSubmitLoader}
              >
                <div className="custom-loader"></div>
              </Backdrop>
              <Typography variant="body2" color="initial" sx={{ alignSelf: "end" }}></Typography>
        </CardContent>
      </Card>
    </Box>
  );
};
